import React from "react";
import { Helmet } from "react-helmet";
import { GhostArticles } from "@minerva-analytics/pantheon";
import { ThemeProvider } from "styled-components";
import { ArticlesContainer, theme, PageTitle, Image } from "./Articles.styles";
import { GHOST_API } from "../../ghost";
import { SITE_URL } from "../../constants";
import { WHITE, DARK_GRAY, BROWN, RED } from "../../theme";

const colors = {
  background: WHITE,
  featuredbg: DARK_GRAY,
  featuredblurb: WHITE,
  title: WHITE,
  published: WHITE,
  author: WHITE,
  readtime: BROWN,
  viewmore: RED,
};

const fonts = {
  title: "Abril Fatface",
  body: "Inter",
};

const Articles = () => {
  return (
    <>
      <Helmet>
        <title>International Recipes & Articles | Cooking & Cocktails</title>
        <meta
          name="og:title"
          property="og:title"
          content="International Recipes & Articles | Cooking & Cocktails"
        />
        <meta
          name="og:description"
          property="og:description"
          content="Learn more about where your favorite international dishes and cocktails come from and check out some of our favorite recipes right here!"
        />
        <meta
          name="description"
          property="description"
          content="Learn more about where your favorite international dishes and cocktails come from and check out some of our favorite recipes right here!"
        />
      </Helmet>
      <ArticlesContainer>
        <ThemeProvider theme={theme}>
          <PageTitle>International Recipes & Articles</PageTitle>
          <Image src="https://storage.googleapis.com/cookingandcocktails-assets/passport.png" />
          <GhostArticles
            domain={SITE_URL}
            ghostApi={GHOST_API}
            colors={colors}
            fonts={fonts}
          />
        </ThemeProvider>
      </ArticlesContainer>
    </>
  );
};

export default Articles;
